/**
 * @description This enumerated value denotes the type of event for the loading-indicator indicator.
 * @enum
 * @export
 * @name LoadingIndicatorEventTypeEnum
 */
export enum LoadingIndicatorEventTypeEnum {

  // This enumerated value denotes the completion of the loading-indicator indicator.
  Complete,

  // This enumerated value denotes the error state of the loading-indicator indicator.
  Error,

  // This enumerated value denotes the hidden state of the loading-indicator indicator.
  Hidden,

  // This enumerated value denotes the progress incrementation of the loading-indicator indicator.
  Progress,

  // This enumerated value denotes the reset of the loading-indicator indicator.
  Reset,

  // This enumerated value denotes the starting of the loading-indicator indicator.
  Start,

  // This enumerated value denotes the stopping of the loading-indicator indicator.
  Stop,

  // This enumerated value denotes the visible state of the loading-indicator indicator.
  Visible,
}
